<template>
  <div class="notifications bottom right" xv-show="active">
    <v-alert text dense xoutlined dismissible  xprominent border="left" :icon="item.icon" :color="item.type" v-for="item in notifications.slice().reverse()" :key="item.id+Math.random()" v-show="item.visible != false" class="mb-2 elevation-2">

    <div class="text-left caption" v-if="item.title && item.title != ''"><strong>{{ item.title }}</strong></div>
    <div class="text-left caption">{{ item.message }}</div>

    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'Notifications',
  data: function() {
    return {
      active: false,
      notifications: []
    };
  },
  computed: {
    visibles() {
      var filtro = this.notifications.filter(function(item) {
        return item.visible === true;
      });
      return filtro.length;
    },
    icon() {
      if (this.visibles) {
        return 'message';
      }
      return 'sms';
    }
  },
  methods: {
    toggle() {
      this.order();
      if (this.active) {
        this.active = false;
        this.closeAll();
      } else {
        this.active = true;
        this.openAll();
      }
    },
    closeAll() {
      this.notifications.map(function(n) {
        n.visible = false;
      });
    },
    openAll() {
      this.notifications.map(function(n) {
        n.visible = true;
      });
    },
    order() {
      //this.notifications =
      //this.notifications = this.notifications.reverse();
    },
    add(notification) {
      if (notification.icon == undefined) { notification.icon = 'mdi-message-reply-text'; }
      else if (notification.type == 'success') { notification.icon = 'mdi-thumb-up'; }
      else if (notification.type == 'error') { notification.icon = 'mdi-alert-circle '; }
      else if (notification.type == 'warning') { notification.icon = 'mdi-alert'; }
      else if (notification.type == 'info') { notification.icon = 'mdi-information'; }

      if (notification.expires == undefined) { notification.expires = 5000; }
      notification = {
        id: Math.floor(Date.now()),
        title: notification.title,
        message: notification.message,
        type: notification.type,
        icon: notification.icon,
        expires: notification.expires,
        visible: true
      };
      if (notification.message) {
        ///context.commit('ADD_NOTIFICATION', notification);

        this.notifications.push(notification);
        // AUTO CLOSE
        if (notification.expires > 0) {
          setTimeout(() => {
            let index = this.notifications.map(item => item.id).indexOf(notification.id);
            this.notifications[index].visible = false;
          }, notification.expires);
        }
      }
    }
  },
  mounted() {
    this.$root.$on('notification', notification => {
      //console.log('notification', notification);
      this.active = true;
      this.add(notification);
    });
    this.$root.$on('notification-toggle', () => {
      this.toggle();
    });
  }
};
</script>

<style>
.notifications {
  padding: 2px;
  width: 400px !important;
  max-width: 100%;
}
.notifications.top {
  position: fixed;
  top: 10px;
  z-index: 9999;
}
.notifications.bottom {
  position: fixed;
  bottom: 44px;
  z-index: 9999;
}
.notifications.right {
  position: fixed;
  right: 10px;
  z-index: 9999;
}
.notifications.left {
  position: fixed;
  left: 10px;
  z-index: 9999;
}
</style>
